 export const environment = {
  production: true,
  urlApiVideos: {
     //url: 'http://172.27.64.25/Api',
    // url: 'https://tecgodev.com',
    // url: 'http://gestorvideospruebas2.ramajudicial.local',
    //url: 'http://192.168.0.37/PortalGrabaciones',
    //url para local ******************
    //url:'http://apigrabaciones.ramajudicial.gov.co/PortalGrabaciones',//Url antigua de maqueta de Mao
    url:'https://apigrabacionescsj.calltechsa.com/PortalGrabaciones',
    //*************************
    //url para maqueta ******************
    //url:'https://apigrabaciones.ramajudicial.gov.co',
    //*************************
    //url:'http://apigestionaudiencias1.ramajudicial.gov.co',
    //url:'https://apigestionaudiencias1.ramajudicial.gov.co',
    // url: 'https://apigestionaudiencias1.ramajudicial.gov.co',
    //backAuthurl: 'http://200.119.47.226:9001',
    //url para local ******************
    //backAuthurl: 'http://apigestionaudiencias3.ramajudicial.gov.co:9001', //Url antigua de maqueta de william
    backAuthurl: 'https://apimaquetacsj.calltechsa.com:9002',
    //*************************
    //url para maqueta**********
    //backAuthurl: 'https://apiagendamiento.ramajudicial.gov.co',
    //**********************
    user: 'USR_A3FAA51025C84819A4ABF550DB4A3ECF',
    password: 'D1B2290324EA479A8AB74B92EE1A82FC'
  },
  title: 'Gestión de videos',
  pageSizes: ['10', '20', '30'],
  urlApiIP: "https://api.ipify.org/?format=json",
  modules: {
    home: 106,
    list_share: 107,
    transliterator: 108,
    statistics: 109,
    detail: 110,
    download: 111,
    tags: 112,
    attachments: 113,
    tagsvideo: 114,
    logs:115,
    ruta_dinamica:116,
    edit:117,
    navigate_transliterator:118,
    deactivate:119,
  }
};
